var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropSelectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31953 0.268945C1.91577 -0.107889 1.28299 -0.0860689 0.906152 0.317682C0.529318 0.721432 0.551138 1.35422 0.954889 1.73106L2.31953 0.268945ZM9.13721 8L8.45489 8.73106L9.13721 9.36789L9.81953 8.73106L9.13721 8ZM17.3195 1.73106C17.7233 1.35422 17.7451 0.721432 17.3683 0.317682C16.9914 -0.0860689 16.3586 -0.107889 15.9549 0.268945L17.3195 1.73106ZM0.954889 1.73106L8.45489 8.73106L9.81953 7.26894L2.31953 0.268945L0.954889 1.73106ZM9.81953 8.73106L17.3195 1.73106L15.9549 0.268945L8.45489 7.26894L9.81953 8.73106Z",
    fill: "#382956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropSelectIcon);
export default __webpack_public_path__ + "static/media/drop-select-icon.e5c7775368b1d380f50d32a5dea637ed.svg";
export { ForwardRef as ReactComponent };